module.exports = __webpack_public_path__ + "img/10-1_03.b823a374.jpg";